// removed by extract-text-webpack-plugin
module.exports = {"flexColumn":"flexColumn__dKC62","flexRow":"flexRow__1OaEj","splitInputErrorText":"splitInputErrorText__2Y9e2","inputErrorText":"inputErrorText__2WLLz"};


//////////////////
// WEBPACK FOOTER
// ./components/salesApp/style.css
// module id = XCwA
// module chunks = 444